//
// [Technician] Typescript Models
//

import Helper, { DateFormat } from "@/services/Helper";

class CredentialModel
{
    constructor (obj?: CredentialModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
        }
    }

    public Id?: string;
    
    public UserId?: number;
    
    public StaffId?: string;
    
    public Type?: string;
    
    public Key?: string;
    
    public Value?: string;

    private _Modified?: string | null = null;

    public get Modified (): string | null 
    {
        return Helper.dateToInput(this.ModifiedAsDate, DateFormat.DateTime) || null;
    }

    public set Modified(val) 
    {
        this._Modified = val || null;
    }

    public get ModifiedAsDate ():Date | null
    {
        if (this._Modified)
        {
            return Helper.dateFromString(this._Modified) || null;
        }

        return null;
    }

    private _Created?: string | null;

    public get Created (): string | null
    {
        return Helper.dateToInput(this.CreatedAsDate, DateFormat.DateTime) || null;
    }

    public set Created(val) 
    {
        this._Created = val || null;
    }

    public get CreatedAsDate ():Date | null
    {
        if (this._Created)
        {
            return Helper.dateFromString(this._Created) || null;
        }

        return null;
    }
}

class TechnicianModel
{
    constructor (obj?: TechnicianModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
            
            if (obj.Credential)
            {
                this.Credential = new CredentialModel(obj.Credential);
            }
        }
        else
        {
            // Set defaults for new records
            this.Active = true;
        }
    }

    public Credential?: CredentialModel;

    public Id?: number;

    public TechnicianName?: string;

    public Email?: string;

    public Active?: boolean;

    public DisplayOnList?: boolean;

    public SortOrder?: number;
}

class UserModel extends TechnicianModel
{
    // ... alias
}

export { UserModel, TechnicianModel }